import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('ID de sesión inválido');
          navigate('/admin');
          return;
        }

        // Exchange session_id for user data and session_token
        const response = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: {
              'X-Session-ID': sessionId
            }
          }
        );

        const { user, session_token } = response.data;

        // Store session token in localStorage
        localStorage.setItem('session_token', session_token);

        // Redirect to admin with user data
        navigate('/admin', { 
          state: { user },
          replace: true 
        });
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Error de autenticación');
        navigate('/admin');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="text-neutral-400">Autenticando...</p>
      </div>
    </div>
  );
}

export default AuthCallback;